import { Component } from "react";
import { withTranslation } from "react-i18next";
import i18n from "i18next";

class SwitchLang extends Component {
  handleLangChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  render() {
    const currentLang = i18n.language || "en";

    return (
      <div style={{ textAlign: "center", marginTop: "1rem" }}>
        {/* تب‌های انتخاب زبان */}
        <form className="tabber">
          {/* زبان انگلیسی */}
          <input
            id="t1"
            name="lang"
            type="radio"
            checked={currentLang === "en"}
            onChange={() => this.handleLangChange("en")}
          />
          <label htmlFor="t1">EN</label>

          {/* زبان فارسی */}
          <input
            id="t2"
            name="lang"
            type="radio"
            checked={currentLang === "fa"}
            onChange={() => this.handleLangChange("fa")}
          />
          <label htmlFor="t2">FA</label>

          <div className="blob"></div>
        </form>
      </div>
    );
  }
}

export default withTranslation()(SwitchLang);
